import React, { useCallback } from 'react';
import { usePersistBoundStore, usePersistSecureBoundStore } from '@/services/zustand/Store';
import { useFocusEffect } from 'expo-router';
import CookieManager from '@react-native-cookies/cookies';
import { useLogoutUser } from '@/services/apis/typo3/useLogoutUser';


export default function LogoutComponent() {
  const logoutStore = usePersistSecureBoundStore((state) => state.logout);
  const updateSessionToken = usePersistBoundStore((state) => state.updateSessionToken);
  const { logoutUser } = useLogoutUser();

  useFocusEffect(
    useCallback(() => {
      const handleLogout = async () => {
        await logoutUser();
        updateSessionToken(null);
        CookieManager.clearAll(true);
        logoutStore();
      };

      handleLogout();
    }, [])
  );

  return (
    <></>
  );
}